import { useState } from "react";

import { localeStorageKey, useI18n } from "../i18n/I18nProvider.js";
import type { Locale } from "../i18n/translations.js";

export function LanguageChooser() {
  const { locale, selectLocale, t } = useI18n();
  const [isOpen, setIsOpen] = useState(
    () => window.localStorage.getItem(localeStorageKey) === null,
  );
  const [pendingLocale, setPendingLocale] = useState<Locale>(locale);

  if (!isOpen) {
    return null;
  }

  const chooseLocale = (nextLocale: Locale) => {
    setPendingLocale(nextLocale);
    selectLocale(nextLocale);
  };

  return (
    <div className="dialog-backdrop">
      <section
        aria-describedby="language-description"
        aria-labelledby="language-title"
        aria-modal="true"
        className="language-dialog"
        role="dialog"
      >
        <p className="eyebrow">{t("language.suggested")}</p>
        <h1 id="language-title">{t("language.dialog_title")}</h1>
        <p id="language-description">{t("language.dialog_body")}</p>
        <div className="language-options">
          {(["th", "en"] as const).map((option) => (
            <button
              aria-pressed={pendingLocale === option}
              className="language-option"
              key={option}
              onClick={() => chooseLocale(option)}
              type="button"
            >
              <span>{t(`language.${option}`)}</span>
              <span aria-hidden="true">{pendingLocale === option ? "✓" : ""}</span>
            </button>
          ))}
        </div>
        <button
          className="button button--primary button--full"
          onClick={() => setIsOpen(false)}
          type="button"
        >
          {t("language.confirm")}
        </button>
      </section>
    </div>
  );
}
